<template>
  <div>
    <NavBarDesktop />
    <main id="main-template">
        <slot />
    </main>
    <UberFooter/>
    <innovative-footer/>
  </div>
</template>

<script>
import NavBarDesktop from '../components/nav-bar'
import InnovativeFooter from '../components/innovative-footer'
import UberFooter from '../components/uber-footer'
export default {
  mounted(){
    window.scroll(0, 0)
  },
  components: { NavBarDesktop,InnovativeFooter,UberFooter },
}
</script>

